import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "tq_cookie_ack";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let acked = false;
    try {
      acked = !!localStorage.getItem(KEY);
    } catch {
      /* ignore */
    }
    if (!acked) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const set = (val) => {
    try {
      localStorage.setItem(KEY, val);
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[9990] sm:w-[420px]"
        >
          <div className="relative border border-white/[0.10] bg-[#0d0d0d]/95 backdrop-blur-xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.9)]">
            <div className="flex items-center gap-2 border-b border-white/10 bg-[#111111] px-4 py-2.5">
              <span className="h-2 w-2 rounded-full bg-white/15" />
              <span className="h-2 w-2 rounded-full bg-white/15" />
              <span className="h-2 w-2 rounded-full bg-[#BACD1C]/60" />
              <span className="ml-2 flex items-center gap-1.5 font-term text-[11px] text-white/45 tracking-[0.15em] lowercase">
                <Cookie size={12} className="text-[#BACD1C]/70" /> cookies.sh
              </span>
              <button
                onClick={() => set("dismissed")}
                data-testid="cookie-dismiss"
                aria-label="Dismiss"
                className="ml-auto text-white/30 hover:text-[#BACD1C] transition-colors"
              >
                <X size={14} />
              </button>
            </div>
            <div className="p-5">
              <p className="font-term text-[10px] uppercase tracking-[0.25em] text-[#BACD1C]/70">// this site uses cookies</p>
              <p className="mt-3 font-term text-[13px] text-white/60 leading-relaxed">
                We use essential and analytics cookies to run the terminal and improve it. No selling
                your data — ever. See our{" "}
                <Link to="/privacy" className="text-[#BACD1C]/80 hover:text-[#BACD1C] underline underline-offset-2">Privacy Policy</Link>.
              </p>
              <div className="mt-5 flex items-center gap-3">
                <button
                  onClick={() => set("accepted")}
                  data-testid="cookie-accept"
                  className="flex-1 bg-[#BACD1C] text-black font-term text-xs uppercase tracking-[0.15em] px-4 py-3 hover:bg-white active:scale-[0.98] transition-[background-color,transform] duration-300"
                >
                  Accept
                </button>
                <button
                  onClick={() => set("essential")}
                  data-testid="cookie-essential"
                  className="font-term text-xs uppercase tracking-[0.12em] border border-white/20 text-white/70 px-4 py-3 hover:border-[#BACD1C]/50 hover:text-[#BACD1C] active:scale-[0.98] transition-colors duration-300"
                >
                  Essential only
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
